import React from 'react';

import Card from '@mui/material/Card';
// import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

// import Accordion from '@mui/material/Accordion';
// import AccordionDetails from '@mui/material/AccordionDetails';
// import AccordionSummary from '@mui/material/AccordionSummary';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import NotesComponent from '../shared/NotesComponent';
import NotesContainer from '../shared/NotesComponent';

function GlobalNotes(props) {
  const relationId = props.relationId;
  const relationType = props.relationType;
  const notesHeading = props.notesHeading;
  return (
    <Card
      style={{
        textAlign: 'left',
        // marginTop: '10px',
        // boxShadow: 'none',
        // background: '#ff00ff',
      }}
    >
      {/* <Accordion sx={{ background: '#b9c9d9' }}> */}
      {/* <Accordion sx={{ background: 'rgb(235, 237, 248)' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1a-content'
          id='panel1a-header'
        > */}
      <Typography variant='h5'>{notesHeading}</Typography>
      {/* </AccordionSummary>
        <AccordionDetails> */}
      <NotesContainer relationId={relationId} relationType={relationType} />
      {/* </AccordionDetails>
      </Accordion> */}
      {/* <TextField
        style={{ width: '98%', margin: 0 }}
        id='outlined-multiline-static'
        variant='outlined'
        multiline
        rows={5}
        defaultValue={customerId}
      />*/}
    </Card>
  );
}

export default GlobalNotes;
